import { RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material'
import React, { FC } from 'react'
import cn from '../../lib/utils/cn'

interface RadioButtonProps {
	label?: string
	value: string | number
	checked: boolean
	onChange: (value: string | number) => void
	disabled?: boolean
	className?: string
	labelClassName?: string
}

const RadioButton: FC<RadioButtonProps> = ({
	label,
	value,
	checked,
	onChange,
	disabled,
	className,
	labelClassName,
}) => {
	return (
		<label
			className={cn(
				'inline-flex items-center gap-2 cursor-pointer select-none',
				disabled && 'opacity-50 cursor-not-allowed',
				className
			)}
			onClick={() => !disabled && onChange(value)}
		>
			{checked ? (
				<RadioButtonChecked className="w-4 h-4 fill-accent" />
			) : (
				<RadioButtonUnchecked className="w-4 h-4 fill-text-secondary" />
			)}
			{label && <span className={cn('text-sm', labelClassName)}>{label}</span>}
		</label>
	)
}

export default RadioButton
